// extracted by mini-css-extract-plugin
module.exports = {"container":"addItem_container__2lAX_","add":"addItem_add__2Qbxj","icon":"addItem_icon__1ac60"};